import { Box, Stack, Typography } from "@mui/material"
import React from "react"

const CheckoutHeader8 = () => {
  return (
    <Box position="absolute" left="0px" right="0px" top="0px" zIndex={1000}>
      <Stack
        sx={{
          py: 2,
          width: "100%",
          background: "linear-gradient(180deg, #ffd57f, #ffd57f)",
          color: "black",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          alignContent="center"
          justifyContent="center"
          sx={{ width: "100%" }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            alignContent="center"
          >
            <Typography fontSize="15px" lineHeight="15px" fontWeight={700}>
              ESTE É UM AMBIENTE 100% SEGURO
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}

export default CheckoutHeader8
